export const STATES_FOR_REGION_REQUESTED = 'states/STATES_FOR_REGION_REQUESTED'
